export enum DriverStatus {
    Active = 'ACTIVE',
    Inactive = 'INACTIVE',
  }

  export enum DriversType {
    Contracted = 'CONTRACTED',
    Freelance = 'FREELANCE',
    Fleet = 'FLEET',
  }

  export enum ExpiredLicensed {
    All = 'ALL',
    Expired = 'EXPIRED',
    NotExpired = 'NOT_EXPIRED',
    AboutToExpire = 'ABOUT_TO_EXPIRE',
  }


  export enum DriverTimeFiltration {
    LastHour = 'LastHour',
    LastTwoHours = 'LastTwoHours',
    LastDay = 'LastDay',
    LastTwoDays = 'LastTwoDays',
    AllTime = 'AllTime'
  }

  export enum MoveToFleetTargets {
    Driver = 'Driver',
    Truck = 'Truck',
    TruckAndDriver = 'TruckAndDriver',
  }

  export enum FleetType {
    Global = 'GLOBAL',
    Specific = 'SPECIFIC'
  }

  export enum CustomerFleetType {
    Global = 'GLOBAL',
    Specific = 'SPECIFIC',
  }

  export enum TruckOperationStatus {
    Operational = 'OPERATIONAL',
    NotOperational = 'NOT_OPERATIONAL',
    StandBy = 'STAND_BY',
    UnderMaintenance = 'UNDER_MAINTENANCE',
    OperationDistribution = 'OPERATION_DISTRIBUTION'
  }

  export enum TruckOwnershipType {
    Owned = 'OWNED',
    Rented = 'RENTED'
  }

  export enum LicenseType {
    PRIVATE_CAR = 'PRIVATE_CAR',
    PUBLIC_TRANSPORTER = 'PUBLIC_TRANSPORTER',
    PRIVATE_TRANSPORTER = 'PRIVATE_TRANSPORTER',
    PUBLIC_MINIBUS = 'PUBLIC_MINIBUS',
    PRIVATE_MINIBUS = 'PRIVATE_MINIBUS',
    TAXI = 'TAXI',
    HEAVY_EQUIPMENT_PUBLIC_WORKS = 'HEAVY_EQUIPMENT_PUBLIC_WORKS',
    EXPORT = 'EXPORT',
    DIPLOMATIC = 'DIPLOMATIC',
    MOTORCYCLE = 'MOTORCYCLE',
    TEMPORARY = 'TEMPORARY',
  }

  export enum Nationality {
    Egyptian = 'EGYPTIAN',
    Saudi = 'SAUDI',
    Indian = 'INDIAN',
    Pakistani = 'PAKISTANI',
    Bangladeshi = 'BANGLADESHI',
    Kuwaiti = 'KUWAITI',
    Sudanese = 'SUDANESE',
    Syrian = 'SYRIAN',
    Yemeni = 'YEMENI',
    Nepali = 'NEPALI',
    SriLankan = 'SRI_LANKAN',
    Philippines = 'PHILIPPINES',
    Afghanistan = 'AFGHANISTAN',
    Eritrean = 'ERITREAN',
    Others ='OTHERS',
  }

  export enum InstallationStatus {
    Downloaded = 'DOWNLOADED',
    NotDownloaded = 'NOT_DOWNLOADED',
  }

  export enum AvlDeviceType {
    Ruptela = 'RUPTELA',
    TeltonikaFMC640 = 'TELTONIKA-FMC640',
    FMC130 = 'FMC130',
  }

  export enum TruckAvailableStatus {
    Available = 'AVAILABLE',
    Assigned = 'ASSIGNED',
    NotAvailable = 'NOT_AVAILABLE',
  }

  export enum TruckVerificationStatus {
    ElmVerified = 'ELM_VERIFIED',
    ElmFailed = 'ELM_FAILED'
}

  export enum TruckClassify {
    AMB = 'AMB',
    Chiller = 'Chiller',
    Frozen = 'Frozen',
    DeepFrozen = 'DeepFrozen',
  }

  export enum OrderTemperature{
    ALL = 'ALL',
    AMB = 'AMB',
    Chiller = 'Chiller',
    Frozen = 'Frozen',
    DeepFrozen = 'Deep_Frozen',
  }
